module.exports = __webpack_public_path__ + "img/toprereg.e442a7ae.png";